
export enum FieldSourceType {
  'Satellite'='satellite',
  'Agro portal'='Agroportal',
  'UAV'='uav',
  'GroundMonitoring'='groundMonitoring',
  'Ia'='ia',
  'Other'='other',
}


export const IdentificationCropSources = [
  // {name: 'OSM', id: FieldSourceType.OSM},
  {name: 'Satellite', id: FieldSourceType.Satellite},
  {name: 'UAV', id: FieldSourceType.UAV},
  {name: 'Ground monitoring', id: FieldSourceType.GroundMonitoring},
  {name: 'Agro portal', id: FieldSourceType['Agro portal']},
  {name: 'OtherFieldSource', id: FieldSourceType.Other},
]

export const IFieldSources = [
  // {name: 'OSM', id: FieldSourceType.OSM},
  {name: 'Ground monitoring', id: FieldSourceType.GroundMonitoring},
  {name: 'AI', id: FieldSourceType.Ia},
  {name: 'UAV', id: FieldSourceType.UAV},
  {name: 'OtherFieldSource', id: FieldSourceType.Other},
]

